import { ChangeDetectionStrategy, Component } from '@angular/core';
import { filter, map, of, startWith, switchMap } from 'rxjs';
import { OperationInputFormService } from '../../operation-input-form.service';

// we want to have nothing selected when no explicit value provided
// also when we reset we just want to have two not selected radio buttons
const DEFAULT_BOOL_OP_VALUE = null;

@Component({
  selector: 'y42-operation-input-boolean',
  templateUrl: './operation-input-boolean.component.html',
  styleUrls: ['./operation-input-boolean.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OperationInputBooleanComponent {
  constructor(private readonly formService: OperationInputFormService) {}

  private get valuesFC() {
    return this.formService.operationsFormArray.controls[0]?.controls?.['values'];
  }

  readonly value$ = this.formService.operationsFormArray.valueChanges.pipe(
    filter(() => this.formService.operationsFormArray.controls.length > 0),
    switchMap(() =>
      this.valuesFC
        ? this.valuesFC.valueChanges.pipe(
            startWith(this.valuesFC?.value || []),
            map((value) => value?.[0] ?? DEFAULT_BOOL_OP_VALUE),
          )
        : of(DEFAULT_BOOL_OP_VALUE),
    ),
    startWith(this.valuesFC?.value?.[0] ?? DEFAULT_BOOL_OP_VALUE),
  );

  patchValue(value: boolean) {
    this.valuesFC?.patchValue([value]);
  }
}
